export const TEMPLATE_PROJECTS = [
  {
    id: 'empty',
    title: 'Blank Project',
    description: 'Start from scratch with an empty project',
    icon: 'app-icons/project',
    categories: [],
  },
  {
    id: 'sample',
    title: 'Interactive Fiction Example',
    description: "A simple example of Arcweave's basic features",
    img: 'cover.jpg',
    categories: [
      {
        id: 'examples',
        label: 'Examples',
      },
    ],
  },
  {
    id: 'youtube-sample',
    title: 'Interactive Movie Example',
    description: 'An example of an interactive short film using YouTube videos',
    img: 'youtube-cover.png',
    categories: [
      {
        id: 'examples',
        label: 'Examples',
      },
    ],
  },
  {
    id: 'game-engine-sample',
    title: 'Game Engine Example',
    description: 'The project used in the game engine integration tutorials',
    img: 'game-engine-cover.png',
    categories: [
      {
        id: 'game-engines',
        label: 'Game Engines',
      },
    ],
  },
  {
    id: 'tabletop-campaign-sample',
    title: 'Tabletop Campaign Example',
    description:
      'A simple plan for a tabletop campaign, complete with dice rolling',
    img: 'tabletop-campaign-cover.png',
    categories: [
      {
        id: 'examples',
        label: 'Examples',
      },
    ],
  },
];
